<section class="workspace-section">
    <div class="section-toolbar">
        <div>
            <h3>Shipment People</h3>
            <p>Sender, receiver, and watchers connected to this shipment.</p>
        </div>
        @if (canManageWatchers()) {
            <p-button label="Add Watcher" severity="help" icon="fa-solid fa-plus" (onClick)="command.emit({ type: 'add-watcher' })"></p-button>
        }
    </div>

    <div class="people-grid">
        @for (nomination of nominations(); track nomination.nominationId || nomination.nominee?.id || $index) {
            <div class="person-card">
                <div class="person-line">
                    <p-avatar [image]="nomination.nominee?.imageUrl || 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'" shape="circle"></p-avatar>
                    <div>
                        <strong>{{ nomination.nominee?.name || 'Contact pending' }}</strong>
                        <span>{{ nomination.client?.name || 'Company pending' }}</span>
                    </div>
                </div>
                <p-tag [value]="nomination.role" severity="info"></p-tag>
                <dl>
                    <div><dt>Email</dt><dd>{{ unavailableEmail(nomination.nominee?.emailAddress) ? 'Not available' : nomination.nominee?.emailAddress }}</dd></div>
                    <div><dt>Phone</dt><dd>{{ nomination.nominee?.phoneNumber || 'Not available' }}</dd></div>
                </dl>
                @if (canNotify()) {
                    <div class="person-actions">
                        <button pButton pTooltip="Send email" type="button" icon="pi pi-envelope"
                            [disabled]="unavailableEmail(nomination.nominee?.emailAddress)"
                            (click)="command.emit({ type: 'send-email', email: nomination.nominee?.emailAddress })"
                            class="p-button-rounded p-button-text p-button-secondary"></button>
                        <button pButton pTooltip="Call" type="button" icon="pi pi-phone"
                            [disabled]="!nomination.nominee?.phoneNumber"
                            (click)="command.emit({ type: 'call', phoneNumber: nomination.nominee?.phoneNumber })"
                            class="p-button-rounded p-button-text p-button-success"></button>
                    </div>
                }
            </div>
        }
    </div>
</section>
@if (consolidationEnabled()) {
<section class="workspace-section participating-clients">
    <div class="section-toolbar"><div><h3>Participating Clients</h3><p>Bill-to parties linked to order releases. Sender, receiver, and watchers above are operational contacts.</p></div></div>
    @if (consolidationLoading()) {
    <p role="status">Loading participating clients…</p>
    } @else if (consolidationError()) {
    <p role="alert">Participating clients could not be loaded. <button type="button" (click)="retryConsolidation.emit()">Retry</button></p>
    } @else if (consolidation()?.sourceStatus === 'UNAVAILABLE') {
    <p>Participating clients are unavailable: this shipment has no allocation snapshot or identifiable linked releases.</p>
    } @else {
    @if (consolidation(); as breakdown) {
        @if (breakdown.sourceStatus === 'RECONSTRUCTED') {<p>Reconstructed from payload release links; no commercial allocation snapshot is available.</p>}
        <div class="participating-list">
        @for (client of breakdown.clients; track client.key) {
            <article class="participating-client">
                <div class="participating-heading"><strong>{{ client.name }}</strong><span>{{ client.parties.length }} bill-to {{ client.parties.length === 1 ? 'party' : 'parties' }} · {{ client.releaseCount }} {{ client.releaseCount === 1 ? 'release' : 'releases' }}</span></div>
                @for (party of client.parties; track party.key) {
                <details class="participating-party">
                    <summary><strong>{{ party.name }}</strong><span>{{ party.releases.length }} {{ party.releases.length === 1 ? 'release' : 'releases' }}</span></summary>
                    <div class="participating-releases">
                    @for (release of party.releases; track release.releaseId) {
                        <div class="participating-release">
                            <a [routerLink]="['/transport-planning/releases', release.releaseId]">{{ release.releaseNumber }}</a>
                            <span>{{ release.status || 'Status unavailable' }} · {{ release.sourceType || 'Source unavailable' }} {{ release.sourceNumber || '' }}</span>
                            @if (release.projectId) {<a [routerLink]="['/logistics-projects', release.projectId]">{{ release.projectNumber || 'Project #' + release.projectId }}</a>}
                            <small>{{ release.originName || 'Origin unavailable' }} → {{ release.destinationName || 'Destination unavailable' }}</small>
                        </div>
                    }
                    </div>
                </details>
                }
            </article>
        }
        </div>
    }
    }
</section>
}
